// import { patientInformationValidations } from "./patientInformationValidations";
import { authorizationToReleaseValidations } from "./authorizationToReleaseValidations";
import { informationToReleaseValidations } from "./informationToReleaseValidations";
import { deliveryMethodValidations } from "./deliveryMethodValidations";
import { purposeOfDisclosureValidations } from "./purposeOfDisclosureValidations";
import { discloseToValidations } from "./discloseToValidations";
import { formLevelValidations } from "./formLevelValidations";
import { supportingDocsValidations, supportingDocsValidationsProxy } from './supportingDocsValidations';
import { caseNumberValidations } from "./caseNumberValidations"
import { patientInfoValidations } from './patientInfoValidations';
import { additionalInfoValidations } from './additionalInfoValidations';
import { discloseSensitiveInfoValidations } from './discloseSensitiveInfoValidations';
import { repInfoValidations } from './repInfoValidations';

export const allValidationsMultilanguage = (configTest, values, formType, dbFormSpec, languageText) => {



    const {
        // patientInformationSection,
        authorizationToReleaseSection,
        supportingDocsSection,
        discloseToSection,
        informationToReleaseSection,
        deliveryMethodSection,
        purposeOfDisclosureSection,
        caseNumberSection,
        repContactInfoSection,
        additionalInfoSection,
        disclosureOfSensitiveInformation
    } = configTest.page.form.sections;


    return patientInfoValidations(repContactInfoSection, formType, languageText)

        // .concat(patientInformationValidations(patientInformationSection))
        .concat(discloseToValidations(discloseToSection))
        .concat(repInfoValidations(formType, languageText))
        .concat(authorizationToReleaseValidations(authorizationToReleaseSection, languageText))
        .concat(discloseSensitiveInfoValidations(disclosureOfSensitiveInformation, languageText))
        .concat(informationToReleaseValidations(informationToReleaseSection, languageText))
        .concat(deliveryMethodValidations(deliveryMethodSection, languageText))
        .concat(purposeOfDisclosureValidations(purposeOfDisclosureSection, languageText))
        .concat(supportingDocsValidations(supportingDocsSection, formType, dbFormSpec, languageText))
        .concat(supportingDocsValidationsProxy(supportingDocsSection, formType, dbFormSpec, languageText))
        .concat(additionalInfoValidations(additionalInfoSection));



    /*
  
.concat(formLevelValidations(configTest.page.form))
.concat(caseNumberValidations(repContactInfoSection.fields.caseNumber))

    .concat()


    */
};
